module.exports = __webpack_public_path__ + "img/logo_ctn_new_2024_color.a8c6e542.png";